import Formulario from "components/Formulario/Formulario";
import { useEffect, useState } from "react";
import PerfisDeAcessoService from 'services/PerfisDeAcessoService';
import { LoadingType } from "../PortalSelect";
import DireitosPortalService from "services/DireitosPortalService";
import CONSTANTES_AMBIENTE from "constants/constantesAmbiente";

function PortalGerenciadorDePerfis ({dadosAdicionados, formRef, data, onFinish, onFinishFailed, ...props}) {
    const [inputsFormulario, setInputsFormulario] = useState([]);

    useEffect(() => {
        gerarInputsFormulario();
    }, []);

    useEffect(() => {
        gerarInputsFormulario();
    }, [data]);

    const listarDireitos = async () => {
        let resultado = [];
        if (data?.listaDireitos.length > 0){
            resultado = data.listaDireitos
        } else {
            resultado = await DireitosPortalService.ListarDireitosGestaoUsuario();
        }
        return filtrarDireitosRetirandoOsQueJaForamAdicionados(resultado);
    }

    const filtrarDireitosRetirandoOsQueJaForamAdicionados = (direitos) => {
        if (!dadosAdicionados || dadosAdicionados.length === 0) return direitos;

        const direitosAdicionados = dadosAdicionados.map(p => p.direito.value);

        const novosDireitos = direitos.filter(function(itm){
            return direitosAdicionados.indexOf(itm.direitoId) === -1;
        });
        return novosDireitos;
    };

    const listarPerfisAcesso = async () => {
        if (data?.deveRestringirPerfis) {
            return [
                { nome: "Administrador de serviços", codigo: CONSTANTES_AMBIENTE.PERFIL_ACESSO.ADMINISTRADOR_SERVICOS },
                { nome: "Usuário Final", codigo: CONSTANTES_AMBIENTE.PERFIL_ACESSO.USUARIO_FINAL }
            ];
        }

        let resultado = [];
        if (data?.listaPerfisAcesso.length > 0){
            return data.listaPerfisAcesso;
        }

        resultado = await PerfisDeAcessoService.ListarTiposPerfisDeAcessoAoDireito();

        return resultado;
    }

    const gerarInputsFormulario = () => {
        const inputs = 
        [
            {
                input:{ 
                    name: "direito",
                    type: "select", 
                    label: "Contrato de Serviço",
                    labelInValue : true,
                    rules: [{required: true, message:"Campo obrigatorio"}],
                    options: {
                        idField: "direitoId", labelField: ["linhaDeServico", "nome"], loadingType: LoadingType.AoRenderizar,
                        callback: async () => {
                            return await listarDireitos();
                        }
                    }
                }
            },
            {
                input:{ 
                    name: "perfil",
                    type: "select", 
                    label: "Perfil de Acesso",
                    labelInValue : true,
                    rules: [{required: true, message:"Campo obrigatorio"}],
                    options: {
                        idField: "codigo", labelField: "nome", loadingType: LoadingType.AoRenderizar,
                        callback: async () => {
                            return await listarPerfisAcesso();
                        }
                    }
                }
            }
        ]

        setInputsFormulario(inputs);
    }

    return(
        <Formulario
            inputsData = {inputsFormulario}
            formReference = {formRef}
            hideSubmitButton = {true}
            onFinish = {onFinish}
            onFinishFailed = {onFinishFailed}
        />
    );
}

export default PortalGerenciadorDePerfis;